<template>
    <li v-if="true">
        <div class="uk-grid uk-grid-large" data-uk-grid-margin>
            <div class="uk-width-7-10">
                <div class="uk-grid uk-grid-small uk-flex-top" data-uk-grid-margin>
                    <div v-if="number_editable" class="uk-form-controls-text uk-text-bold uk-width-1-5 uk-margin-small-top">
                        Number
                    </div>
                    <div v-if="number_editable" class="uk-width-4-5">
                        <form-input
                            id="number"
                            v-model="project.number"
                            name="number"
                            :error="has_error('number')"
                            :required="false"
                            :editable="true"
                            width="1-1"
                            placeholder="Project number"
                            @input="save_field"
                            class="uk-width-1-1"
                        />
                    </div>

                    <div class="uk-form-controls-text uk-text-bold uk-width-1-5" :class="{ 'uk-margin-small-top': !number_editable, 'uk-margin-top': !!number_editable }">
                        Project Name
                    </div>
                    <div class="uk-width-4-5">
                        <form-input
                            id="name"
                            v-model="project.name"
                            name="name"
                            :error="has_error('name')"
                            :required="true"
                            :editable="can_edit_prospective_data"
                            width="1-1"
                            placeholder="Project name"
                            @input="save_field"
                            class="uk-width-1-1"
                        />
                    </div>

                    <div class="uk-form-controls-text uk-text-bold uk-width-1-5 uk-margin-top">
                        Scope Name
                    </div>
                    <div class="uk-width-4-5">
                        <form-input
                            id="nickname"
                            v-model="project.nickname"
                            name="nickname"
                            :error="has_error('nickname')"
                            :required="false"
                            :editable="can_edit_prospective_data"
                            width="1-1"
                            placeholder="Scope name (nickname)"
                            @input="save_field"
                            class="uk-width-1-1"
                        />
                    </div>

                    <div class="uk-form-controls-text uk-text-bold uk-width-1-5 uk-margin-top" :class="{'uk-text-required': !project.size}">
                        <open-icon v-if="!project.size" glyph="exclamation-triangle" />
                        Project Size
                    </div>
                    <div class="uk-width-4-5">
                        <form-size-control
                            id="size"
                            name="size"
                            unit-name="size_units"
                            :value="project"
                            :required="false"
                            :editable="can_edit_prospective_data"
                            class="uk-width-2-5"
                            @input="save_field"
                        />
                    </div>

                    <div class="uk-form-controls-text uk-text-bold uk-width-1-5 uk-margin-top">
                        Project Construction Budget
                    </div>
                    <div class="uk-width-4-5">
                        <form-input
                            id="construction_budget"
                            type="float"
                            v-model="project.construction_budget"
                            name="construction_budget"
                            glyph="dollar"
                            :error="has_error('construction_budget')"
                            :required="false"
                            :editable="can_edit_prospective_data"
                            width="1-1"
                            @input="save_field"
                            class="uk-width-1-1"
                        />
                    </div>

                    <div class="uk-form-controls-text uk-text-bold uk-width-1-5 uk-margin-top" :class="{'uk-text-required': !project_physical_address.city}">
                        <open-icon
                            v-if="!project_physical_address.city"
                            glyph="exclamation-triangle"
                            class="uk-margin-right"
                        />
                        Location
                    </div>
                    <div class="uk-width-4-5">
                        <div v-if="can_edit_prospective_data || (project_physical_address && project_physical_address.line1)" :class="{'uk-text-required': !project_physical_address.city}" class="uk-flex uk-flex-middle">
                            <auto-save-address-form
                                v-model="project_physical_address"
                                :editable="can_edit_prospective_data"
                                entity="address"
                                class="uk-width-1-1"
                            />
                        </div>
                    </div>

                    <div class="uk-form-controls-text uk-text-bold uk-width-1-5">
                        Marketing-worthy
                    </div>
                    <div class="uk-width-4-5">
                        <form-checkbox
                            id="consider_for_marketing"
                            v-model="project.consider_for_marketing"
                            name="consider_for_marketing"
                            :editable="can_edit_prospective_data"
                            :required="false"
                            @input="save_field"
                        />
                    </div>

                    <div class="uk-form-controls-text uk-width-1-5 uk-margin-top">
                        <span class="uk-text-bold">Project Types</span><!-- (2 max) //-->
                    </div>
                    <div class="uk-width-4-5">
                        <category-picker
                            id="project"
                            v-model="project.category_ids"
                            :filtered="project_is_overhead(project) ? 'overhead' : 'regular'"
                            :editable="can_edit_prospective_data"
                            title="Project Type(s)"
                            subtitle="Please limit selections (typically 1-2 per category) and only include major and important spaces in Project Keywords"
                            @change="toggle_category"
                        />
                    </div>
                </div>
            </div>
            <div class="uk-width-3-10">
                <div v-if="!!project" class="uk-grid uk-grid-small uk-flex-top lam-status-grid" data-uk-grid-margin>
                    <div class="uk-width-1-1">
                        <div id="status-picker" class="uk-form-controls-text uk-text-bold uk-width-1-1">
                            <a
                                v-if="project.is_latest_project && (is_business_manager || is_db_admin_active)"
                                href
                                title="Undo this project's activation - make it a Prospective Project again"
                                class="uk-button uk-button-mini uk-button-primary"
                                @click.prevent="deactivate"
                            >
                                <open-icon glyph="undo" />
                            </a>
                            Status
                        </div>
                        <form-select
                            id="project_status"
                            name="project_status"
                            :value="project.project_status"
                            :options="project_statuses"
                            id-field="code_constant"
                            :editable="status_editable"
                            :required="true"
                            class="uk-width-1-1"
                            @input="change_status"
                        >
                            <template v-slot:read_only>
                                {{ project_status_label(record.project_status) }}
                            </template>
                        </form-select>
                        <div
                            v-if="!!project && !!project.project_status && !project.project_status.match(/^(pending)$/)"
                            class="uk-width-1-1 uk-margin-top"
                        >
                            <form-text-area
                                v-if="status_editable && !!project && !!project.project_status && !project.project_status.match(/^(active)$/)"
                                id="project_status_notes"
                                entity="project"
                                name="project_status_notes"
                                v-model="project.project_status_notes"
                                placeholder="Please explain..."
                                width="1-1"
                                :required="false"
                                @input="save_field"
                            />
                            <p v-else-if="!!project.project_status_notes" class="uk-text-center">{{ project.project_status_notes }}</p>
                        </div>
                    </div>
                </div>
                <div class="uk-grid uk-flex-top uk-margin-top" data-uk-grid-margin>
                    <div class="uk-width-1-2">
                        <div class="uk-grid uk-grid-small uk-flex-top" data-uk-grid-margin>
                            <div v-if="!project_is_overhead(project)" class="uk-text-bold uk-width-3-10 uk-margin-small-top uk-text-nowrap" :class="{'uk-text-required': !pic||!pic.id}">
                                <open-icon v-if="!pic||!pic.id" glyph="exclamation-triangle" />
                                PIC
                            </div>
                            <div v-if="!project_is_overhead(project)" class="uk-width-7-10">
                                <form-select-user
                                    id="pic_id"
                                    name="pic_id"
                                    :value="project.pic_id"
                                    :filter="pics_filter"
                                    :editable="can_edit_prospective_data"
                                    :required="true"
                                    class="uk-width-1-1"
                                    @input="change_team"
                                />
                            </div>

                            <div class="uk-text-bold uk-width-3-10 uk-margin-top">
                                PM
                            </div>
                            <div class="uk-width-7-10">
                                <form-select-user
                                    id="pm_id"
                                    name="pm_id"
                                    :value="project.pm_id||0"
                                    :filter="pms_filter"
                                    empty-label="(No PM)"
                                    :editable="can_edit_prospective_data"
                                    :required="false"
                                    class="uk-width-1-1"
                                    @input="change_team"
                                />
                            </div>
                            <div class="uk-text-bold uk-width-1-1 uk-margin-top">
                                Studio(s)
                            </div>
                            <div v-for="studio in raw_studio_records" :key="studio.id" class="uk-width-1-1 uk-form-controls-text">
                                <form-checkbox
                                    :id="`studio-${studio.id}`"
                                    :value="project.studio_ids.indexOf(studio.id)>=0"
                                    name="studio_ids"
                                    :editable="can_edit_prospective_data"
                                    @input="toggle_studio(studio.id, $event)"
                                >
                                    {{ studio.name }}
                                </form-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="uk-width-1-2">
                        <div class="uk-grid uk-grid-small uk-flex-top" data-uk-grid-margin>
                            <div class="uk-text-bold uk-width-1-1 uk-margin-small-top">
                                Designer(s)
                            </div>
                            <div class="lam-designer-pickers">
                                <div
                                    v-for="designer_id in sorted_designer_ids"
                                    :key="designer_id"
                                    class="uk-button-group lam-designer-picker"
                                >
                                    <base-button
                                        class="lam-designer-picker-remove"
                                        @click.prevent="remove_designer(designer_id)"
                                    >
                                        <open-icon glyph="close" />
                                    </base-button>
                                    <base-button
                                        :disabled="true"
                                        class="lam-designer-picker-initials"
                                    >
                                        {{ designer_by_id(designer_id).initials }}
                                    </base-button>
                                    <base-button
                                        class="lam-designer-picker-star"
                                        @click.prevent="designer_toggle_star(designer_id)"
                                    >
                                        <open-icon :glyph="project_user_by_id(designer_id).starred ? 'star' : 'star-o'" />
                                    </base-button>
                                    <dropdown-button
                                        data-uk-dropdown="{pos:'bottom-right'}"
                                        class="lam-designer-picker-dropdown"
                                    >
                                        <template v-slot:dropdown>
                                            <ul class="uk-nav uk-nav-dropdown">
                                                <li
                                                    v-for="designer in available_designers(designer_id)"
                                                    :key="designer.id"
                                                >
                                                    <a href @click.prevent="change_team(designer.id, 'designer_ids', designer_id)">
                                                        {{ designer.initials }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </template>
                                        <open-icon glyph="chevron-down" />
                                    </dropdown-button>
                                </div>
                                <div
                                    v-if="available_designers(0).length"
                                    class="uk-button-group lam-designer-picker add-new"
                                >
                                    <dropdown-button
                                        data-uk-dropdown="{pos:'bottom-right'}"
                                        class="lam-designer-picker-dropdown"
                                    >
                                        <template v-slot:dropdown>
                                            <ul class="uk-nav uk-nav-dropdown">
                                                <li
                                                    v-for="designer in available_designers(0)"
                                                    :key="designer.id"
                                                >
                                                    <a href @click.prevent="change_team(designer.id, 'designer_ids')">
                                                        {{ designer.initials }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </template>
                                        <open-icon glyph="plus" />
                                    </dropdown-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal-dialog
            id="status-change-confirmation"
            :show.sync="confirming_status_change"
        >
            <template v-slot:title>
                Change status to "{{ project_status_label(status_change_to) }}"
            </template>

            <form class="uk-form" @submit.prevent>
                <h5>Are you sure you want to change this project's status to "{{ project_status_label(status_change_to) }}"?</h5>
                <p class="uk-text-muted">NOTE: You might not be able to undo this change, and you might lose access to the project as a result...</p>

                <div v-if="(status_change_to==='active') && !!project && (!project.scopes_data || !project.scopes_data.scopes || !!all_other_team_project_ids.length)">
                    <form-checkbox
                        v-if="!project.scopes_data || !project.scopes_data.scopes"
                        id="activate_as_scope"
                        v-model="activate_as_scope"
                        name="activate_as_scope"
                        :editable="true"
                    >
                        Activate as a scope of an existing project...
                    </form-checkbox>
                    <div v-if="activate_as_scope" class="uk-margin-small-top uk-padding-left">
                        <div class="uk-flex uk-flex-center" style="align-items: flex-end;">
                            <div class="uk-flex-item-1-1">
                                <div class="uk-form-controls-text uk-text-bold">Existing Project Number</div>
                                <form-input
                                    id="scope_number"
                                    v-model="scope_number"
                                    name="scope_number"
                                    placeholder="00000"
                                    :required="true"
                                    :editable="true"
                                    width="1-1"
                                    class="uk-width-1-1"
                                />
                            </div>
                            <label class="uk-flex-item-none uk-margin-small-left uk-margin-small-right">.</label>
                            <div class="uk-flex-item-none">
                                <div class="uk-form-controls-text uk-text-bold">New Scope's Suffix</div>
                                <form-input
                                    id="scope_suffix"
                                    v-model="scope_suffix"
                                    name="scope_suffix"
                                    placeholder="10"
                                    :required="true"
                                    :editable="true"
                                    width="1-5"
                                    class="uk-width-1-1"
                                />
                            </div>
                        </div>
                        <div v-if="has_error('scope_number')" class="uk-form-help-block uk-text-center uk-text-danger">
                            {{ has_error('scope_number') }}
                        </div>
                        <div v-else class="uk-form-help-block uk-text-center uk-text-muted">
                            (Leave the suffix field empty and it will be automatically assigned)
                        </div>
                    </div>
                    <div v-if="all_other_team_project_ids.length" class="uk-margin-top">
                        <div class="uk-form-controls-text uk-text-bold">Close Other Team Projects:</div>
                        <ul class="uk-list uk-list-line">
                            <li
                                v-for="id in all_other_team_project_ids"
                                :key="id"
                            >
                                <form-checkbox
                                    id="other_team_project_ids"
                                    :value="other_team_project_ids.indexOf(id) >= 0"
                                    name="other_team_project_ids"
                                    :editable="true"
                                    @input="toggle_other_team_project_id(id)"
                                >
                                    <span v-if="!!project_by_id(id).number">{{ project_by_id(id).number }} </span>{{ project_by_id(id).nickname || project_by_id(id).name }}
                                    <div v-if="!!project_by_id(id).client_name" class="uk-text-small">{{ project_by_id(id).client_name }}</div>
                                </form-checkbox>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="status_change_to==='dead'">
                    <p>Please pick a reason below:</p>
                    <form-select
                        id="dead_status_reason"
                        name="dead_status_reason"
                        v-model="dead_status_reason"
                        :empty-value="0"
                        empty-label="(Pick a reason)"
                        :options="dead_reasons"
                        :editable="true"
                        :required="true"
                        class="uk-width-1-1"
                    />
                </div>

                <div class="uk-modal-footer uk-text-center">
                    <base-button
                        size="large"
                        width="1-1"
                        @click.prevent="cancel_status_change(true)"
                    >
                        No, forget it
                    </base-button>
                    <base-button
                        color="primary"
                        size="large"
                        width="1-1"
                        :disabled="!can_change_status"
                        :waiting="changing_status"
                        @click.prevent="execute_status_change"
                    >
                        Yes, change to "{{ project_status_label(status_change_to) }}"
                    </base-button>
                </div>
            </form>
        </modal-dialog>
    </li>
    <li v-else>
        <project-data
            :record="project"
            :editable="can_edit_prospective_data"
            :wizard-shown="wizardShown"
            :activatable="activatable"
            @wizard="toggle_page_wizard"
            @status-change-done="reset_status_ui"
        />

        <location
            v-if="!project_is_overhead(project)"
            :record="project"
            :editable="can_edit_prospective_data"
            :wizard-shown="wizardShown"
        />

        <project
            :record="project"
            :editable="can_edit_prospective_data"
            :wizard-shown="wizardShown"
        />

        <project-sustainability-programs
            :record="project"
            :editable="can_edit_prospective_data"
        />

        <!--
        <file-transfers
            :record="project"
            :editable="can_edit_prospective_data"
            :wizard-shown="wizardShown"
        />
        //-->

        <budget
            :record="project"
            :editable="can_edit_prospective_data"
            :wizard-shown="wizardShown"
        />
        <!--
        <pricing
            :record="project"
            :editable="can_edit_prospective_data"
        />
        //-->

        <lighting
            :record="project"
            :editable="can_edit_prospective_data"
        />

        <!--
        <incentives
            :record="project"
            :editable="can_edit_prospective_data"
        />
        //-->
    </li>
</template>

<script type="text/javascript">
import orderBy from "lodash/orderBy"

import tab from "../mixins/Tab"
import project_utilities from "../../../mixins/ProjectUtilities"
import handles_saving from "../../../mixins/HandlesSaving"
import has_addresses from "../../../mixins/HasAddresses"
import wizard_target from "../mixins/WizardTarget"

import FormInput from "../../../ui/FormInput"
import FormCheckbox from "../../../ui/FormCheckbox"
import FormTextArea from "../../../ui/FormTextArea"
import FormSizeControl from "../../../ui/FormSizeControl"
import FormSelect from "../../../ui/FormSelect"
import FormSelectUser from "../../../ui/FormSelectUser"
import AutoSaveAddressForm from "../../../ui/AutoSaveAddressForm"
import CategoryPicker from "../../../ui/CategoryPicker"
import ModalDialog from "../../../dialogs/ModalDialog/ModalDialog"
import BaseButton from "../../../ui/BaseButton"
import DropdownButton from "../../../ui/DropdownButton"
import OpenIcon from "../../../ui/OpenIcon"

import ProjectData from "./ProjectData"
import Location from "./Location"
import Project from "./Project"
// import FileTransfers from './FileTransfers'
import Budget from "./Budget"
// import Pricing from './Pricing'
import Lighting from "./Lighting"
// import Incentives from './Incentives'
import ProjectSustainabilityPrograms from "./ProjectSustainabilityPrograms"

export default {
    mixins: [tab, project_utilities, handles_saving, has_addresses, wizard_target],
    components: {
        FormInput,
        FormCheckbox,
        FormTextArea,
        FormSizeControl,
        FormSelect,
        FormSelectUser,
        AutoSaveAddressForm,
        CategoryPicker,
        ModalDialog,
        BaseButton,
        DropdownButton,
        OpenIcon,
        ProjectData,
        Location,
        Project,
        Budget,
        Lighting,
        ProjectSustainabilityPrograms
    },
    mounted () {
        this.reset_record_info()
    },
    watch: {
        project: "reset_record_info",
        activatable: "proceed_with_status_change"
    },
    methods: {
        reset_record_info () {
            this.record_id = this.project ? this.project.id : 0
        },
        toggle_page_wizard (value) {
            this.$emit("wizard", value)
        },
        toggle_category (checked, category_id) {
            const index = this.project.category_ids.indexOf(category_id)
            if(checked && (index < 0)) this.project.category_ids.push(category_id)
            else if(!checked && (index >= 0)) this.project.category_ids.splice(index, 1)
            this.save_field(this.project.category_ids, "category_ids")
        },
        deactivate () {
            this.$confirm({
                type: "error",
                title: "Delete Comment",
                message: "Are you sure you want to revert this to a prospective project?",
                cancel: "No, leave it active",
                ok: "Yes, revert",
                then: (confirmed) => {
                    if(confirmed) {
                        this.$store.dispatch("DEACTIVATE_RECORD", {
                            entity: "project",
                            id: this.project.id
                        }).catch(error => {
                            if(error) this.$error(error.message)
                        }).then(() => {
                            this.$router.push({ name: "prospective_project.edit", params: { id: this.project.id } })
                        })
                    }
                }
            })
        },
        project_status_label (project_status) {
            return this.term_value_by(project_status, "project_status").replace(/^-\s+(.+)\s+-$/, "$1")
        },
        project_by_id (id) {
            return this.entity_records("project").find(project => project.id === id) || {}
        },
        available_designers (user_id) {
            return orderBy(this.filtered_designers.filter(user => {
                return !user.deleted_at && ((user.id === user_id) || (this.record.designer_ids.indexOf(user.id) < 0))
            }), "initials", "asc")
        },
        designer_by_id (user_id) {
            return this.entity_records("user").find(user => (user.id === user_id)) || { initials: user_id }
        },
        project_user_by_id (user_id) {
            return this.entity_records("project_user").find(project_user => (project_user.project_id === this.record.id) && (project_user.user_id === user_id)) || {}
        },
        toggle_other_team_project_id (id) {
            const index = this.other_team_project_ids.indexOf(id)
            if(index >= 0) this.other_team_project_ids.splice(index, 1)
            else this.other_team_project_ids.push(id)
        },
        revert_status () {
            this.$nextTick(() => {
                this.record.project_status = this.original_project_status
                this.original_project_status = ""
            })
        },
        change_status (new_status) {
            this.all_other_team_project_ids = []
            if(!!this.project && !!this.project.project_group_id) this.all_other_team_project_ids = this.entity_records("project").filter(project => (project.id !== this.project.id) && (project.project_group_id === this.project.project_group_id)).map(project => project.id)
            this.other_team_project_ids = [...this.all_other_team_project_ids]
            this.activate_as_scope = !!this.record.activation_scope_number
            this.scope_number = this.record.activation_scope_number || ""
            this.scope_suffix = ""

            this.original_project_status = this.record.project_status
            this.status_change_to = new_status
            this.record.project_status = new_status
            if(new_status.match(/^(active|dead|declined)$/i)) this.dead_status_reason = 0
            if(new_status.match(/^(active|dead|declined|other)$/i)) {
                if(this.record.activated_at) this.save_new_status(new_status)
                else if(this.activatable) {
                    if(new_status.match(/^(other)$/i)) this.save_new_status(new_status)
                    else this.confirming_status_change = true
                } else {
                    this.record.project_status = new_status
                    this.revert_status()

                    this.toggle_page_wizard(new_status)
                }
            } else this.save_new_status(new_status)
        },
        cancel_status_change (revert = false) {
            this.reset_status_ui()
            this.status_change_to = ""
            this.confirming_status_change = false
            if(revert) this.revert_status()
            else this.held_project_status = ""
        },
        execute_status_change () {
            this.clear_all_errors()
            if(this.activate_as_scope && !this.scope_number) this.add_error("scope_number", "Please provide an existing project number.", false)
            else {
                // dead_status_reason
                let notes = ""
                if(this.status_change_to === "dead") notes = this.term_value(this.dead_status_reason, this.dead_reasons)
                this.save_new_status(this.status_change_to, notes)
            }
        },
        save_new_status (project_status, project_status_notes = "") {
            this.changing_status = true
            const data = {
                project_status,
                project_status_notes,
                other_team_projects: this.other_team_project_ids
            }
            if(this.activate_as_scope && this.scope_number) {
                data.scope_number = this.scope_number
                data.scope_suffix = this.scope_suffix
            }
            this.$store.dispatch("RECORD_SAVE", {
                entity: "project",
                id: this.project.id,
                data
            }).then(record => {
                if(project_status === "active") this.$router.replace({ name: "project.edit", params: { id: this.project.id } })
                this.reset_status_ui()
                this.cancel_status_change()
            }).catch(error => {
                this.$error(error.message)
            }).then(() => {
                this.changing_status = false
            })
        },
        proceed_with_status_change () {
            if(this.project && !!this.status_change_to && this.activatable) {
                this.change_status(this.status_change_to)
            }
        },
        pics_filter (user) {
            return !!this.project && this.user_can_be_pic(user) && (this.project.designer_ids.indexOf(user.id) < 0)
        },
        pms_filter (user) {
            return !!this.project && this.user_can_be_pm(user, this.project.internal) && (this.project.pic_id !== user.id) && (this.project.designer_ids.indexOf(user.id) < 0)
        },
        change_team (value, field, old_user_id = 0) {
            if(field === "pm_id") value = value || null
            else if(field === "designer_ids") {
                const designer_ids = [...(this.project.designer_ids || [])]
                const index = designer_ids.indexOf(old_user_id || value)
                if(index >= 0) designer_ids[index] = `${designer_ids[index]}->${value}`
                else if(value) designer_ids.push(value)
                value = designer_ids
            }
            this.save_field(value, field).then(() => {
                const team_member_ids = [
                    this.project.pic_id,
                    this.project.pm_id || 0,
                    ...(this.project.designer_ids || [])
                ]
                const project_users = this.entity_records("project_user").filter(project_user => project_user.project_id === this.project.id)
                const task_users = this.entity_records("task_user").filter(task_user => task_user.project_id === this.project.id)
                project_users.forEach(project_user => {
                    if(team_member_ids.indexOf(project_user.user_id) < 0) this.$store.dispatch("DUSTING", { entity: "project_user", record_id: project_user.id })
                })
                task_users.forEach(task_user => {
                    if(team_member_ids.indexOf(task_user.user_id) < 0) this.$store.dispatch("DUSTING", { entity: "task_user", record_id: task_user.id })
                })
            })
        },
        toggle_studio (studio_id, checked) {
            const index = this.project.studio_ids.indexOf(studio_id)
            if(checked && (index < 0)) this.project.studio_ids.push(studio_id)
            else if(!checked && (index >= 0)) this.project.studio_ids.splice(index, 1)
            this.save_field(this.project.studio_ids, "studio_ids")
        },
        designer_toggle_star (user_id) {
            this.$store.dispatch("RECORD_ACTION",
                {
                    entity: "project",
                    id: this.project,
                    action: `user/${user_id}/toggle_star`,
                    method: "post"
                }
            ).catch(error => {
                this.$error("<strong>" + error.header + "</strong><br>" + error.message)
            })
        },
        remove_designer (user_id) {
            const designer = this.designer_by_id(user_id)
            if(!designer) return
            this.$confirm({
                type: "error",
                title: `Remove ${designer.initials}`,
                message: "Are you sure you want to remove '" + designer.initials + "' from this project? Any assigned time will be deleted also.",
                cancel: "Keep",
                ok: "Remove",
                then: (confirmed) => {
                    if(confirmed) this.change_team(0, "designer_ids", user_id)
                }
            })
        },
        reset_status_ui () {
            this.$emit("status-change-done")
        }
    },
    computed: {
        number_editable () {
            return this.project && this.project.internal && this.can_edit_prospective_data
        },
        status_editable () {
            if(this.project && this.project.internal) return true
            if(!this.can_edit_prospective_data || !this.profile || !this.project) return false
            if(this.is_administrator || this.is_business_manager || this.is_associate_principal || this.is_principal || this.im_pic_or_pm || this.is_db_admin_active) return true
            return false
        },
        is_active () {
            return this.project_is_active(this.record)
        },
        is_active_locked () {
            if(this.project && this.project.internal) return false
            if(!this.can_edit_prospective_data || !this.project || !this.profile) return true
            if(this.project.activated_at) { // only the biz or db admin can edit
                if(this.is_administrator || this.is_business_manager || this.is_db_admin_active) return false
                return true
            }
            return !this.can_edit_prospective_data
        },
        project_physical_address () {
            return this.physical_address("App\\Project", this.project.id)
        },
        prospective_project_statuses () {
            const project_statuses = this.dictionary("project_status", "name")
            let stati = project_statuses.filter((term) => {
                if(this.deactivating) {
                    if(term.code_constant.match(/^(chosen-)?pending$/i)) return true
                } else {
                    // if(term.code_constant.match(/^(on-hold|(chosen-)?pending|declined|other)$/i)) return true
                    if(term.code_constant.match(/^((chosen-)?pending|declined|other)$/i)) return true
                    if((term.code_constant.match(/^(dead)$/i)) && (!this.project.activated_at || this.is_business_manager || this.im_pic_or_pm || this.my_project || this.is_db_admin_active)) return true
                    if((term.code_constant.match(/^(active)$/i)) && (this.is_business_manager || this.im_pic_or_pm || this.my_project || this.is_db_admin_active)) return true
                }
                return false
            })
            if(!this.deactivating) {
                stati = stati.map((term) => {
                    if((term.code_constant === "active") && !term.name.match(/-\s.+?\s-/)) term.name = "- " + term.name + " -"
                    return term
                })
            }
            return stati
        },
        project_statuses () {
            if(!this.project || !this.project.activated_at) return this.prospective_project_statuses

            const project_statuses = this.dictionary("project_status", "name")
            if(!this.status_editable) return project_statuses

            return project_statuses.filter((term) => {
                if(term.code_constant.match(/^(on-hold|active|completed)$/i)) return true
                if((term.code_constant.match(/^(dead)$/i)) && (this.is_business_manager || this.is_administrator || this.im_pic_or_pm || this.is_db_admin_active)) return true
                return false
            })
        },
        can_change_status () {
            if(!this.activatable && (this.status_change_to === "dead")) {
                if(this.has_required_data("category_ids") && !this.has_required_data("size")) {
                    const type_of_request = this.types_of_request.find(type_of_request => type_of_request.id === this.record.type_of_request)
                    if(type_of_request && (type_of_request.code_constant === "architect")) return true
                }
            }
            return this.activatable
        },
        pic () {
            return this.pic_for_project(this.project)
        },
        pm () {
            return this.pm_for_project(this.project)
        },
        sorted_designer_ids () {
            if(!this.project) return []
            return orderBy(this.project.designer_ids, (designer_id) => {
                const project_user = this.entity_records("project_user").find(project_user => (project_user.project_id === this.project.id) && (project_user.user_id === designer_id))
                const designer = this.designer_by_id(designer_id)
                if(!!project_user && project_user.starred) return `1.${designer.initials}`
                return `2.${designer.initials}`
            }, "asc")
        },
        filtered_designers () {
            if(!this.project) return []
            return this.raw_user_records.filter(user => (user.role <= (this.project.internal ? this.$root.constants.roles.ADMIN.id : this.$root.constants.roles.PRINCIPAL.id)) && (user.id !== this.project.pic_id) && (user.id !== this.record.pm_id))
        },
        raw_studio_records () {
            return this.entity_records("studio")
        },
        dead_reasons () {
            return this.dictionary("dead_reasons")
        }
    },
    props: {
        activatable: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            entity: "project",

            confirming_status_change: false,
            original_project_status: "",
            status_change_to: "",
            dead_status_reason: 0,
            changing_status: false,

            all_other_team_project_ids: [],
            other_team_project_ids: [],
            activate_as_scope: false,
            scope_number: "",
            scope_suffix: ""
        }
    }
}
</script>
